<template>
  <v-radio-group
    v-model="selectedIds"
    class="ma-0 pa-0"
    :hide-details="'auto'"
    :rules="rules"
  >
    <v-checkbox
      v-for="option in options"
      class="mt-0 mb-4 pa-0"
      color="blue"
      hide-details
      v-model="selectedIds"
      :key="option.id"
      :label="option.name"
      :rules="rules"
      :value="option.id"
      :disabled="loading"
      @click.native.prevent.stop.capture="handleChange(option.id)"
    />

    <LinkedFindingWarningDialog
      :show="openWarningModal"
      @cancel="openWarningModal = false"
      @continue="handleContinue"
    />
  </v-radio-group>
</template>

<script>
import _ from 'lodash'

import LinkedFindingWarningDialog from './LinkedFindingWarning.vue'

export default {
  name: 'CheckboxesForm',

  components: {
    LinkedFindingWarningDialog,
  },

  props: {
    options: {
      type: Array,
      required: true,
    },
    response: {
      type: Array, // Option ids
      required: false,
      default: () => [],
    },
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    hasFinding: Boolean,
  },

  data() {
    return {
      selectedIds: [...(this.response ?? [])],
      selectionBeforeModal: [],
      openWarningModal: false,
    }
  },

  methods: {
    checkIfRequired(ids) {
      return this.options.some(
        option => option.requiresFinding && ids.includes(option.id)
      )
    },

    handleChange(val) {
      const newSelectedIds = _.xor(this.selectedIds, [val])
      const doesValueRequiresFinding = this.checkIfRequired(newSelectedIds)

      if (this.hasFinding && !doesValueRequiresFinding) {
        this.selectionBeforeModal = newSelectedIds
        this.openWarningModal = true
      } else {
        this.selectedIds = newSelectedIds
        this.$emit('change', newSelectedIds)
      }
    },

    handleContinue() {
      this.selectedIds = this.selectionBeforeModal
      this.$emit('handleWarningContinue', this.selectionBeforeModal)
      this.openWarningModal = false
    },
  },
}
</script>
